import React, { useState } from "react";
import PaidPayments from "./paid-payments";
import PendingPayments from "./pending-payments";
import UpcomingPayments from "./upcoming-payments";

const PaymentsPage = () => {
  const [activeTab, setActiveTab] = useState("paid");

  return (
    <div className="container-fluid mt-3 ">
      <h3>Payments</h3>

      {/* 🔹 Tabs */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "paid" ? "active" : ""}`}
            onClick={() => setActiveTab("paid")}
          >
            Paid
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "pending" ? "active" : ""}`}
            onClick={() => setActiveTab("pending")}
          >
            Pending
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "upcoming" ? "active" : ""}`}
            onClick={() => setActiveTab("upcoming")}
          >
            Upcoming
          </button>
        </li>
      </ul>

      {/* 🔹 Render Active Component */}
      <div className="my-3 ">
        {activeTab === "paid" && <PaidPayments />}
        {activeTab === "pending" && <PendingPayments />}
        {activeTab === "upcoming" && <UpcomingPayments />}
      </div>
    </div>
  );
};

export default PaymentsPage;
